var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goods_detial_home"},[(_vm.showNormalDetail)?_c('normal-detail'):_vm._e(),(_vm.showBlindBoxDetail)?_c('blind-box-detail'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }